import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Users, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { staff } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";

export default function StaffLogin() {
  const navigate = useNavigate();
  const { setMerchant } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await staff.login({ email, password });
      localStorage.setItem("oc_token", res.token);
      localStorage.setItem("oc_merchant", JSON.stringify(res.merchant));
      localStorage.setItem("oc_staff", JSON.stringify(res.staff));
      setMerchant(res.merchant);
      toast.success(`Welcome, ${res.staff.name} (${res.staff.role})`);
      setTimeout(() => { window.location.href = "/dashboard"; }, 300);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login gagal");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="mb-6"><Logo /></div>
        <div className="bg-white border border-gray-200 rounded-xl p-8">
          <div className="flex items-center gap-2 text-xs font-bold tracking-widest uppercase text-emerald-600">
            <Users size={14} /> Staff Login
          </div>
          <h1 className="mt-3 font-heading text-2xl font-bold text-gray-900">Masuk sebagai Staff</h1>
          <p className="mt-2 text-sm text-gray-500">Login untuk staff Marketing, CS, atau Finance yang sudah diundang oleh Merchant Owner.</p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label>Email</Label><Input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="h-11" data-testid="staff-login-email" /></div>
            <div><Label>Password</Label><Input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="h-11" data-testid="staff-login-password" /></div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold" data-testid="staff-login-btn">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              Masuk
            </Button>
          </form>
          <div className="mt-6 text-center text-xs text-gray-500">
            Bukan staff? <Link to="/login" className="text-emerald-600 font-semibold hover:underline">Login sebagai Merchant Owner</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
